// extracted by mini-css-extract-plugin
module.exports = {"card":"ProfileReview_card__J0Esv","reviewMeta":"ProfileReview_reviewMeta__47UhT","text":"ProfileReview_text__QZZZW"};